export enum AutomationEvent {
    DELETED = 'automation-deleted',
    RENAMED = 'automation-renamed',
    UPDATED = 'automation-updated',
    UPDATED_VERSION = 'automation-updated-version',
}

export interface AutomationUpdatedVersionPayload {
    success: boolean;
    successCount: number;
    failureCount: number;
    total: number;
}

export interface AutomationEventMap {
    [AutomationEvent.DELETED]: void;
    [AutomationEvent.RENAMED]: void;
    [AutomationEvent.UPDATED]: void;
    [AutomationEvent.UPDATED_VERSION]: AutomationUpdatedVersionPayload;
}
